import { render, staticRenderFns } from "./ScrollArrow.vue?vue&type=template&id=6bbcff72&scoped=true"
import script from "./ScrollArrow.vue?vue&type=script&lang=js"
export * from "./ScrollArrow.vue?vue&type=script&lang=js"
import style0 from "./ScrollArrow.vue?vue&type=style&index=0&id=6bbcff72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcff72",
  null
  
)

export default component.exports